/* Lorens Cart Gift Offer - attribute-based, single threshold (500 ILS after discounts).
 * Pairs with snippets/lor-cart-gift-offer.liquid (rendered in .lor-cart-side).
 * Ported from the FlyByFly gift picker (Impact theme). The choice is written to
 * cart.attributes['מתנה'] (not as a line item). Impact re-renders the drawer on cart
 * changes; a MutationObserver on #cart-drawer drives stale-choice cleanup and re-binding.
 * Loaded once from layout/theme.liquid.
 */
(function () {
  if (window.__lorGiftOfferBound) return;
  window.__lorGiftOfferBound = true;

  var THRESHOLD = 50000; /* agorot */
  var GIFT_KEY = 'מתנה';
  var ACT_SEL = '[data-lor-go-toggle],[data-lor-go-swap],[data-lor-go-pick]';

  function onCartPage() {
    try { return window.location && window.location.pathname.indexOf('/cart') === 0; } catch (e) { return false; }
  }

  function swapSnippet() {
    return fetch('/?sections=cart-drawer', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (sections) {
        if (!sections || !sections['cart-drawer']) return;
        var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var fresh = doc.querySelector('[data-lor-gift-offer]');
        var live = document.querySelectorAll('[data-lor-gift-offer]');
        if (fresh && live.length) {
          live.forEach(function (el) { el.outerHTML = fresh.outerHTML; });
        }
        bindDirect();
      })
      .catch(function () {});
  }

  function refreshCart() {
    if (onCartPage()) { window.location.reload(); return; }
    swapSnippet();
  }

  function cartGet() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function updateAttributes(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  /* Clear the gift when the cart drops below the threshold or the pick is no
   * longer one of the current options. */
  function autoRemoveStaleAttributes() {
    return cartGet().then(function (cart) {
      var attrs = cart.attributes || {};
      var val = attrs[GIFT_KEY];
      if (!val) return { removed: false, cart: cart };
      var stale = cart.total_price < THRESHOLD;
      if (!stale) {
        var wrap = document.querySelector('[data-lor-gift-offer]');
        var list = wrap && wrap.getAttribute('data-lor-valid');
        if (list) {
          var titles = list.split('||').map(function (s) { return s.trim(); }).filter(Boolean);
          if (titles.length && titles.indexOf(val) === -1) stale = true;
        }
      }
      if (!stale) return { removed: false, cart: cart };
      var upd = {};
      upd[GIFT_KEY] = '';
      return updateAttributes(upd).then(function () { return { removed: true, cart: cart }; });
    }).catch(function () { return { removed: false, cart: null }; });
  }

  /* Hebrew translation of Shopify's English-only availability errors inside the drawer. */
  var ERR_PATTERNS = [
    [/Only (\d+) items? (?:was|were) added to your cart due to availability\.?/, function (n) {
      return n === '1' ? 'נוספה רק יחידה אחת לעגלה, זו הכמות שיש כרגע במלאי.'
                       : 'נוספו רק ' + n + ' יחידות לעגלה, זו הכמות שיש כרגע במלאי.';
    }],
    [/All (\d+) items? (?:is|are) in your cart\.?/, function (n) {
      return n === '1' ? 'היחידה האחרונה שבמלאי כבר נמצאת בעגלה.'
                       : 'כל ' + n + ' היחידות שבמלאי כבר בעגלה.';
    }]
  ];
  function translateCartErrors() {
    var scope = document.getElementById('cart-drawer');
    if (!scope) return;
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (tn) {
      var t = tn.textContent;
      ERR_PATTERNS.forEach(function (pair) {
        var m = t.match(pair[0]);
        if (m) t = t.replace(pair[0], pair[1](m[1]));
      });
      if (t !== tn.textContent) tn.textContent = t;
    });
  }

  function activate(el) {
    if (el.hasAttribute('data-lor-go-toggle')) {
      var picker = el.closest('[data-lor-go-picker]');
      if (!picker) return;
      var opts = picker.querySelector('[data-lor-go-opts]');
      if (!opts) return;
      var isOpen = !opts.hasAttribute('hidden');
      if (isOpen) {
        opts.setAttribute('hidden', '');
        picker.classList.remove('lor-go--open');
      } else {
        opts.removeAttribute('hidden');
        picker.classList.add('lor-go--open');
        setTimeout(function () { try { opts.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {} }, 60);
      }
      return;
    }

    if (el.hasAttribute('data-lor-go-swap')) {
      var block = el.closest('[data-lor-go-block]');
      if (!block) return;
      var done = block.querySelector('[data-lor-go-done]');
      var pk = block.querySelector('[data-lor-go-picker]');
      if (done) done.style.display = 'none';
      if (pk) {
        pk.classList.remove('lor-go--initially-hidden');
        pk.style.display = '';
        var opts2 = pk.querySelector('[data-lor-go-opts]');
        if (opts2) {
          opts2.removeAttribute('hidden');
          pk.classList.add('lor-go--open');
          setTimeout(function () { try { opts2.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {} }, 80);
        }
      }
      return;
    }

    if (el.hasAttribute('data-lor-go-pick')) {
      if (el.disabled) return;
      var title = el.getAttribute('data-variant-title');
      if (!title) { console.error('[lor-go] pick: missing variant title'); return; }
      var pickerEl = el.closest('.lor-go--picker');
      if (pickerEl) pickerEl.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
      el.style.opacity = '0.6';
      var attrs = {};
      attrs[GIFT_KEY] = title;
      updateAttributes(attrs)
        .then(function (r) {
          if (!r.ok) { return r.text().then(function (txt) { throw new Error('update failed ' + r.status + ': ' + txt); }); }
          return r.json();
        })
        .then(function () { refreshCart(); })
        .catch(function (err) {
          console.error('[lor-go] update failed', err);
          if (pickerEl) pickerEl.querySelectorAll('button').forEach(function (b) { b.disabled = false; });
          el.style.opacity = '';
          alert('שגיאה בשמירת הבחירה. נסי שוב.');
        });
    }
  }

  /* direct binding (iOS-safe), re-applied after every re-render */
  function bindDirect() {
    document.querySelectorAll(ACT_SEL).forEach(function (el) {
      if (el.__lorGoDirect) return;
      el.__lorGoDirect = true;
      el.addEventListener('click', function (e) { e.preventDefault(); activate(el); });
    });
  }

  /* delegated fallback (skips directly-bound elements) */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var t = e.target.closest(ACT_SEL);
    if (!t || t.__lorGoDirect) return;
    e.preventDefault();
    t.__lorGoDirect = true;
    activate(t);
  });

  var debounceTimer = null;
  var inFlight = false;
  function onCartChanged() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      if (inFlight) return;
      inFlight = true;
      autoRemoveStaleAttributes()
        .then(function (res) {
          inFlight = false;
          if (res.removed) return swapSnippet();
          var body = document.getElementById('cart-drawer');
          if (body && res.cart && res.cart.item_count > 0 && !document.querySelector('[data-lor-gift-offer]')) {
            return swapSnippet();
          }
        })
        .catch(function () { inFlight = false; });
    }, 200);
  }

  function observe() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    new MutationObserver(function () {
      bindDirect();
      translateCartErrors();
      onCartChanged();
    }).observe(drawer, { childList: true, subtree: true });
  }

  function init() {
    observe();
    bindDirect();
    translateCartErrors();
    autoRemoveStaleAttributes().then(function (res) { if (res.removed) swapSnippet(); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
